import React, { Component } from 'react'
import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import HeadingBanner from 'components/Text/HeadingBanner'
import EmptyMessageCard from 'components/Cards/EmptyMessageCard'
import { Table, TableHeader, TableRow } from 'features/Table'
import { Crumbs } from 'components/BreadCrumbs'
import Button from 'components/Button'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import sAnim from 'components/Animation/Animation.scss'
import { Field } from 'redux-form'
import SelectPretty from 'components/Input/SelectPretty'
import s from './Numbers.scss'
import Pagination from 'components/Pagination'
import { sortBy } from 'lodash'
import { Input } from 'components/Input/Input'
import IconPlus from 'components/Icons/Plus'
import Tooltip from 'components/Tooltip/Tooltip'

const order = {
  'In Progress': 0,
  Active: 1,
  Inactive: 2,
  Churned: 3,
}

export default class Numbers extends Component {
  componentWillMount() {
    const { getNumbers } = this.props
    getNumbers()
  }
  render() {
    const {
      services,
      showNumbersNewServiceModal,
      servicesLoading,
      formData,
      replace,
      page,
      location,
    } = this.props

    const matcher = !!formData.search
      ? new RegExp(formData.search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')
      : new RegExp('')

    const serviceTypeOptions = [
      {
        name: 'Any',
        value: '',
      },
    ]

    // get unique service types for filter
    services
      .map(service => service.serviceType)
      .reduce(
        (uniqueTypes, type) =>
          uniqueTypes.includes(type) ? uniqueTypes : uniqueTypes.push(type) && uniqueTypes,
        []
      )
      .map(type => serviceTypeOptions.push({ name: type, value: type }))

    const servicesFiltered = services.filter(service => {
      const serviceTypeMatch = !formData.serviceType || service.serviceType === formData.serviceType

      const searchTextMatch =
        !formData.search ||
        (!!service.number && service.number.includes(formData.search)) ||
        (!!service.id && service.id.includes(formData.search)) ||
        (!!service.customerReference && matcher.test(service.customerReference))

      return serviceTypeMatch && searchTextMatch
    })

    const servicesOrdered = sortBy(servicesFiltered, [service => order[service.billingStatus] || 0])
    const numPerPage = 40

    const tableHeader = (
      <TableHeader>
        <div>Number</div>
        <div className={s['refColumn']}>Ref</div>
        <div className={cn(sLay['hide-xs'], s['statusColumn'])}>Status</div>
        <div className={sLay['hide-xs']}>Service Type</div>
        <div className={cn(sLay['hide-xs'], s['flowsColumn'])}>Flows</div>
        <div style={{ maxWidth: '76px' }} />
      </TableHeader>
    )

    return (
      <Page layout={{ header: 'app' }} title="Numbers">
        <PageHeader>
          <Crumbs title="Numbers" />
        </PageHeader>
        <Container paddingTop paddingBottom className={sAnim.comeUp}>
          <div className={cn(sMarg.mb30, sLay['layout-row'])}>
            <Field
              label="Search"
              component={Input}
              name="search"
              display="box"
              hideDot
              classNameOuter={s['searchBox']}
            />
            <Field
              className={s.statusDropdown}
              label="Service Type"
              component={SelectPretty}
              name="serviceType"
              options={serviceTypeOptions}
              display="box"
            />
            <Button
              className={s.createButton}
              color="tertiary"
              size="sm"
              rect
              onClick={() => showNumbersNewServiceModal()}
            >
              <IconPlus size={32} />
              <Tooltip>Add New Service</Tooltip>
            </Button>
          </div>
          {!servicesOrdered || servicesOrdered.length === 0 ? (
            <EmptyMessageCard
              loading={servicesLoading}
              title="You have no Number Services"
              subtitle="You can register both 1300 and 1800 numbers with Pickle. Learn more and register:"
            >
              <Button color="primary" to="/1300">
                1300
              </Button>
              <Button color="tertiary" to="/1800">
                1800
              </Button>
            </EmptyMessageCard>
          ) : (
            <Table header={tableHeader}>
              {servicesOrdered.slice((page - 1) * numPerPage, page * numPerPage).map(service => (
                <TableRow key={service.id}>
                  <div>{service.number}</div>

                  <div className={s['refColumn']}>
                    {service.customerReference || service.friendlyName}
                  </div>

                  <div className={cn(sLay['hide-xs'], s['statusColumn'])}>
                    {service.billingStatus || 'Active'}
                  </div>

                  <div className={sLay['hide-xs']}>{service.serviceType}</div>

                  <div className={cn(sLay['hide-xs'], s['flowsColumn'])}>
                    {service.twilioCallFlowId ||
                    service.twilioSmsFlowId ||
                    service.twilioFaxFlowId ||
                    service.twilioFlowServiceId
                      ? '✓'
                      : ''}
                  </div>

                  <div style={{ maxWidth: '76px' }}>
                    <Button
                      disabled={service.billingStatus === 'Inactive'}
                      color="tertiary"
                      size="xs"
                      ghost
                      to={`/dashboard/numbers/${service.id}`}
                    >
                      View
                    </Button>
                  </div>
                </TableRow>
              ))}
            </Table>
          )}
          <Pagination
            page={page}
            numPages={Math.ceil(servicesOrdered.length / numPerPage)}
            onClick={nextPage => {
              replace({
                pathname: location.pathname,
                query: {
                  page: nextPage,
                },
              })
            }}
          />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Numbers/Numbers.jsx